import { NgIf } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, Component, TemplateRef, ViewChild } from '@angular/core';
import { AgrI18nSharedModule } from '@next/core-lib/i18n';

@Component({
  templateUrl: './column-external-invoice-id-for-return.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIf, AgrI18nSharedModule],
})
export class ColumnExternalInvoiceIdForReturnComponent implements AfterViewInit {
  @ViewChild('template') template: TemplateRef<unknown>;
  public initCallback: () => void;
  public externalInvoiceIdForReturnFallback: string;

  ngAfterViewInit() {
    this.initCallback();
  }
}
